import {Component, Input} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {RestClient} from "../rest-client.service";
import {Router} from "@angular/router";
import {AuthService} from '../base/auth/auth.service';
import {NotificationsService} from '../notifications/notifications.service';
import {EnumNotificationType, OneTimeNotificationDto} from "../model/dto.model";

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-notifications>',
    template: `

        <p-dialog header="" [(visible)]="dialogVisible" [style]="{ width: '450px' }" [draggable]="false"
                  [resizable]="false">
            <div *ngFor="let pNotify of modelNotifications" class="d-flex">
                <div class="BsWid30p"><i class="pi pi-info-circle BsFsLarge"></i></div>
                <div class="d-col ">{{ pNotify.messageId | i18n: pNotify.messageParams }}</div>
            </div>
            <div class="Separator MarV-xl"></div>
            <div class="TexAlCenter d-flex f-gap-l">
                <button pButton [label]="v('deactivate_notifications')" (click)="onDisableNotifications()" class="OrangeBack d-col"></button>
                <button pButton [label]="v('close')" (click)="dialogVisible=!dialogVisible" class="d-col"></button>
            </div>
        </p-dialog>
    `
})
export class NotificationsComponent extends BaseComponent {

    @Input() modelNotificationType: EnumNotificationType;
    HOURS_24: number = 86400000;
    HOURS_2: number = 3600000;
    dialogVisible: boolean = false;
    modelNotifications: OneTimeNotificationDto[] = []

    constructor(private restClient: RestClient, private router: Router,
                private notificationsService: NotificationsService, private auth: AuthService) {
        super();
    }

    ngOnInit(): void {

        // Home-notificationsService (announcement with time range)
        const lastNotificatonCheck = this.notificationsService.lastNotificationsCheckedAt[this.auth.findCurrentSession().cpNr];
        const checkedInLast24Hours = lastNotificatonCheck && lastNotificatonCheck.getTime() > new Date().getTime() - this.HOURS_24;
        if (!checkedInLast24Hours) {
            this.notificationsService.lastNotificationsCheckedAt[this.auth.findCurrentSession().cpNr] = new Date();
            this.restClient
                .getNotifications()
                .subscribe(notifications => {
                    this.notificationsService.notifications[this.auth.findCurrentSession().cpNr] = notifications;
                    const userConfirmation = notifications.length == 1 && notifications[0].entity.confirmation ? notifications[0] : undefined;
                    if (userConfirmation) {
                        this.router.navigate(['/user-confirmation']);
                    } else {
                        notifications
                            .filter(notification => !notification.entity.confirmation)
                            .forEach(notification => this.toastInfoSticky(this.i18n.extractTextWithFallBack(notification.i18nTexts)));
                    }
                });
        }

        // Personalised-notificationsService (one-time, business notification)
        const pLastPersCheck = this.notificationsService.lastNotificationsPersCheckedAt[this.auth.findCurrentSession().cpNr];
        const pCheckedInLast2Hours = pLastPersCheck && pLastPersCheck.getTime() > new Date().getTime() - this.HOURS_2;
        if (!pCheckedInLast2Hours) {
            this.restClient
                .getNotificationsPersonalised()
                .subscribe(aNotifications => {
                    this.notificationsService.lastNotificationsPersCheckedAt[this.auth.findCurrentSession().cpNr] = new Date();
                    if (aNotifications?.length) {
                        this.modelNotifications = aNotifications;
                        this.dialogVisible = this.modelNotifications?.length > 0;
                    }
                });
        }
    }

    onDisableNotifications() {
        this.restClient.profileInfo().subscribe(aProfile => {
            // update profile
            aProfile.notifyPlanChangedActive = false;
            this.restClient.saveProfile(aProfile).subscribe(() => {
                this.dialogVisible = false;
                this.toastInfoSticky(this.v('notifications_deactivated'), 6000);
            });
        });

    }
}
